import axios from "axios";
import { language } from "../translations";
import { encrypt, decrypt, toastify } from "../utils";
import { captureApiError } from "./sentry";

const TIMEOUT = 20000;

const getDefaultHeaders = () => ({
  // "Api-Version": "v1",
  // "x-api-key": "f949840d-31b9-4750-9e93-533d1d44834f",
  // "Accept-Language": language,
  "Content-Type": "application/json",
  // Accept: "application/json",
});

const getAccessToken = () => localStorage.getItem("access");
const getRefreshToken = () => localStorage.getItem("refreshToken");

const createApiService = ({
  baseURL,
  apiCall = "normalCall",
  timeout = TIMEOUT,
}) => {
  const client = axios.create({
    baseURL,
    timeout,
    headers: getDefaultHeaders(),
  });

  // Request interceptor
  client.interceptors.request.use(
    (config) => {
      const token =
        apiCall === "refreshCall" ? getRefreshToken() : getAccessToken();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      
      // Don't set Content-Type for FormData - let browser set it automatically
      if (config.data instanceof FormData) {
        delete config.headers["Content-Type"];
      }
      
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      captureApiError(error, { apiCall, fallbackTimeout: TIMEOUT });
      

      // Handle token expiration or invalid access globally
      // if (status === 401) {
      //   toastify("error", "Session expired. Please login again.");

      
      //   localStorage.clear();

        
      //   if (typeof window !== "undefined") {
      //     window.location.href = "/login";
      //   }

      //   return Promise.reject({
      //     ...error,
      //     message: "Unauthorized – redirected to login",
      //   });
      // }

      return Promise.reject(error);
    }
  );

  // Methods
  const get = (path, params = {}) =>
    client.get(path, { params }).then((res) => res.data);

  const post = (path, payload) =>
    client.post(path, JSON.stringify(payload)).then((res) => res.data);
  const patch = (path, payload) =>
    client.patch(path, JSON.stringify(payload)).then((res) => res.data);

  const imgPost = (path, payload) =>
    client.post(path, payload).then((res) => JSON.parse(decrypt(res.data)));

  const formDataPost = (path, payload) =>
    client.post(path, payload).then((res) => res.data);

  const put = (path, payload) => {
    const encrypted = encrypt(JSON.stringify(payload));
    return client
      .put(path, encrypted)
      .then((res) => JSON.parse(decrypt(res.data)));
  };

  const del = (path, payload = {}) => {
    return client.delete(path, { data: payload }).then((res) => res.data);
  };

  return {
    get,
    post,
    imgPost,
    formDataPost,
    put,
    patch,
    delete: del,
  };
};

export default createApiService;
